import CFDCompareAccounts from './cfd-compare-accounts';
import './cfd-compare-accounts.scss';

export default CFDCompareAccounts;
